//Resolved self-reference in object literal and syntax error in string literal
import enGB from 'rsuite/locales/en_GB';
import { el } from 'date-fns/locale'; // Import Greek date-fns locale for months & formatting

// Define DateTimeFormats separately to avoid self-reference
const DateTimeFormats = {
  ...enGB.DateTimeFormats,
  // Key for date-fns Greek locale—handles month names like 'Ιανουάριος'
  dateLocale: el,
  // Calendar weekday labels (object keys, not arrays)
  sunday: 'Κυρ',
  monday: 'Δευ',
  tuesday: 'Τρι',
  wednesday: 'Τετ',
  thursday: 'Πεμ',
  friday: 'Παρ',
  saturday: 'Σαβ',
  // Other calendar strings
  ok: 'OK',
  today: 'Σήμερα',
  yesterday: 'Χθες',
};

const elGR = {
  ...enGB,
  // Shared date/time formats across Calendar, DatePicker, etc.
  DateTimeFormats,
  // Apply DateTimeFormats to Calendar
  Calendar: {
    ...enGB.Calendar,
    ...DateTimeFormats, // Spread to inherit days, dateLocale, etc.
  },
  // Apply to DatePicker
  DatePicker: {
    ...enGB.DatePicker,
    ...DateTimeFormats,
    placeholder: 'Επιλέξτε ημερομηνία',
  },
  DateRangePicker: {
    ...enGB.DateRangePicker,
    ...DateTimeFormats,
  },
};

export default elGR;
